import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./DealTable.css";

export default function LeadTable({
  leads = [],
  page = 1,
  limit = 100,
  selectedLeads = [],
  toggleLead,
  handleSelectAll,
  showBulkMenu,
  setShowBulkMenu,
  setShowStageModal,
  setShowSourceModal,
  openAssignModal,
  handleDeleteSelected,
}) {
  const navigate = useNavigate();
  const { user } = useAuth();
const formatResponseTime = (seconds) => {
  if (
    seconds === null ||
    seconds === undefined ||
    seconds === ""
  ) {
    return "-";
  }

  const totalMinutes = Math.floor(Number(seconds) / 60);

  if (totalMinutes < 1) {
    return "< 1 min";
  }

  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;

  if (days > 0) {
    return `${days}d ${hours}h`;
  }

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }

  return `${minutes}m`;
};
  const stageColor = (stage) => {
    switch (stage) {
      case "New Lead":
        return "#6B7280";

      case "Contacted":
        return "#2563EB";

      case "Inbound":
        return "#0891B2";

      case "Prospect":
        return "#CA8A04";

      case "DNP":
        return "#DC2626";

      case "Qualified":
        return "#CA8A04";

      case "Meeting Done":
        return "#059669";

      case "Site Visit":
        return "#0891B2";

      case "Negotiation":
        return "#9333EA";

      case "Closed Won":
        return "#16A34A";

      case "Closed Lost":
        return "#DC2626";

      default:
        return "#6B7280";
    }
  };

  const menuItem = {
    padding: "10px 14px",
    cursor: "pointer",
    fontSize: 13,
    borderBottom: "1px solid #eee",
    whiteSpace: "nowrap",
  };

  return (
    <div className="deal-table-wrapper">
      <table className="deal-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Lead Date</th>
            <th>Time</th>
            <th>Client Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Stage</th>
            <th>Next Follow-up</th>
<th>Question</th>
<th>Assigned</th>
<th>Last Comment</th>
<th>Source</th>
<th>Campaign</th>
            <th>Budget</th>
            <th>Calls</th>
<th>Response Time</th>
<th>Follow-ups</th>

            <th style={{ width: 70 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <input
                  type="checkbox"
                  checked={
                    leads.length > 0 &&
                    selectedLeads.length === leads.length
                  }
                  onChange={handleSelectAll}
                />

                {selectedLeads.length > 0 && (
                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    <button
                      type="button"
                      onClick={(event) => {
                        event.stopPropagation();
                        setShowBulkMenu(!showBulkMenu);
                      }}
                      style={{
                        width: 16,
                        height: 16,
                        border: "none",
                        borderRadius: 4,
                        background: "#16A34A",
                        color: "#fff",
                        fontSize: 12,
                        fontWeight: 700,
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 0,
                        lineHeight: 1,
                      }}
                      onMouseEnter={(event) => {
                        event.currentTarget.style.background =
                          "#15803D";
                      }}
                      onMouseLeave={(event) => {
                        event.currentTarget.style.background =
                          "#16A34A";
                      }}
                    >
                      ▼
                    </button>

                    {showBulkMenu && (
                      <div
                        style={{
                          position: "absolute",
                          top: "110%",
                          right: 0,
                          width: 210,
                          background: "#fff",
                          border: "1px solid #E5E7EB",
                          borderRadius: 8,
                          boxShadow:
                            "0 8px 24px rgba(0,0,0,.12)",
                          zIndex: 999,
                          overflow: "hidden",
                        }}
                      >
                        {["admin", "sales_head", "team_lead"].includes(user?.role) && (
                          <div
                            style={menuItem}
                            onClick={(event) => {
                              event.stopPropagation();
                              openAssignModal();
                            }}
                          >
                            Assign Leads
                          </div>
                        )}

                        <div
                          style={menuItem}
                          onClick={(event) => {
                            event.stopPropagation();
                            setShowStageModal(true);
                            setShowBulkMenu(false);
                          }}
                        >
                          Update Stage
                        </div>

                        <div
                          style={menuItem}
                          onClick={(event) => {
                            event.stopPropagation();
                            setShowSourceModal(true);
                            setShowBulkMenu(false);
                          }}
                        >
                          Update Source
                        </div>

                        {user?.role === "admin" && (
                          <div style={menuItem}>
                            Update Selected
                          </div>
                        )}

                        {user?.role === "admin" && (
                          <div style={menuItem}>
                            Bulk Update
                          </div>
                        )}

                        {user?.role === "admin" && (
                          <div style={menuItem}>
                            Drop Leads
                          </div>
                        )}

                        <div style={menuItem}>
                          Send SMS
                        </div>

                        <div style={menuItem}>
                          Send WhatsApp
                        </div>

                        <div style={menuItem}>
                          Send Email
                        </div>

                        {user?.role === "admin" && (
                          <div
                            style={{
                              ...menuItem,
                              color: "#DC2626",
                              borderBottom: "none",
                            }}
                            onClick={(event) => {
                              event.stopPropagation();
                              handleDeleteSelected();
                            }}
                          >
                            Delete Selected
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          {leads.length === 0 ? (
            <tr>
              <td
                colSpan="17"
                className="empty"
              >
                No Leads Found
              </td>
            </tr>
          ) : (
            leads.map((lead, index) => {
              const isDuplicate =
                lead.is_duplicate === true;

              const isSelected =
                selectedLeads.includes(lead.id);

              return (
                <tr
                  key={lead.id}
                  className="deal-row"
                  onClick={() =>
                    toggleLead(lead.id)
                  }
                  style={{
                    background: isSelected
                      ? "#ECFDF5"
                      : isDuplicate
                      ? "rgba(220, 38, 38, 0.025)"
                      : undefined,
                    cursor: "pointer",
                  }}
                >
                  <td>
                    {(page - 1) * limit +
                      index +
                      1}
                  </td>

                  <td>
                    {lead.created_at
                      ? new Date(
                          lead.created_at
                        ).toLocaleDateString(
                          "en-GB"
                        )
                      : "-"}
                  </td>

                  <td>
                    {lead.created_at
                      ? new Date(
                          lead.created_at
                        ).toLocaleTimeString(
                          "en-IN",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        )
                      : "-"}
                  </td>

                  <td
                    onClick={(event) => {
  event.stopPropagation();

  window.open(`/leads/${lead.id}`, "_blank");
}}
                  >
                    <strong
                      style={{
                        fontSize: 14,
                        color: isDuplicate
                          ? "#DC2626"
                          : "#222",
                        fontWeight: 700,
                        cursor: "pointer",
                        textDecoration: "none",
                      }}
                      onMouseEnter={(event) => {
                        event.currentTarget.style.textDecoration =
                          "underline";
                      }}
                      onMouseLeave={(event) => {
                        event.currentTarget.style.textDecoration =
                          "none";
                      }}
                    >
                      {lead.name ||
                        "Unnamed Lead"}
                    </strong>
                  </td>

                  <td>
                    {lead.phone || "-"}
                  </td>

                  <td>
                    {lead.email || "-"}
                  </td>

                  <td>
                    <span
                      style={{
                        background: `${stageColor(
                          lead.stage
                        )}20`,
                        color: stageColor(
                          lead.stage
                        ),
                        padding: "5px 12px",
                        borderRadius: 20,
                        fontSize: 12,
                        fontWeight: 600,
                      }}
                    >
                      {lead.stage || "-"}
                    </span>
                  </td>

                  <td>
                    {lead.next_follow_up_at ? (
                      <div>
                        <div>
                          {new Date(
                            lead.next_follow_up_at
                          ).toLocaleDateString(
                            "en-GB"
                          )}
                        </div>

                        <div
                          style={{
                            marginTop: 2,
                            fontSize: 11,
                            color: "#777",
                          }}
                        >
                          {new Date(
                            lead.next_follow_up_at
                          ).toLocaleTimeString(
                            "en-IN",
                            {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            }
                          )}
                        </div>
                      </div>
                    ) : (
                      "-"
                    )}
                  </td>

                  <td
                    style={{
                      maxWidth: 220,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow:
                        "ellipsis",
                    }}
                    title={lead.notes}
                  >
                    {lead.notes || "-"}
                  </td>

                  <td>
  {lead.assigned_to_name ||
    "Unassigned"}
</td>

<td
  style={{
    maxWidth: 250,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }}
  title={lead.last_comment || ""}
>
  {lead.last_comment || "-"}
</td>

<td>
  <span
    style={{
      padding: "4px 10px",
      background: "#F3F4F6",
      borderRadius: 20,
      fontSize: 12,
    }}
  >
    {(lead.source ||
      "Unknown")
      .split("(")[0]
      .trim()}
  </span>
</td>

                  <td>
                    {lead.campaign_name ||
                      "-"}
                  </td>

                  <td className="money">
                    {Number(
                      lead.budget_cr || 0
                    ) > 0
                      ? `₹${lead.budget_cr} Cr`
                      : "-"}
                  </td>

                  <td>
  {Number(
    lead.follow_up_count || 0
  )}
</td>
<td>
  {formatResponseTime(
    lead.response_time_seconds
  )}
</td>
                  <td>
                    {Number(
                      lead.follow_up_count ||
                        0
                    )}
                  </td>

                  <td
                    onClick={(event) =>
                      event.stopPropagation()
                    }
                  >
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() =>
                        toggleLead(lead.id)
                      }
                    />
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}